export const environment = {
  production: false,
  idUrl: 'https://idtest1.schoolsbuddy.net',
  oldApiUrl: 'https://devbuddy-test.azurewebsites.net',
  apiUrl: 'https://devbuddyapi-test1.azurewebsites.net',
  angularUrl: 'https://devbuddyngx-test1.azurewebsites.net',
  organisingUrl: 'https://organising-test1.schoolsbuddy.net',
  blobBase: 'https://devbuddytest.blob.core.windows.net/',
  cdnBase: 'https://devbuddycdn-test1.azureedge.net/',
  enableClarity: true,
  enablePendo: false,
  pendoExclusionSubdomains: null,
  loaderImg: 'SB-vertical-full-color.png',
  serverId: '2',
  froalaLicenceKey: 'Ig1A7vB3A1A1B1D2D4F4I1GqgA-13kOPVi1b1b2Le2e1G1AWMSGSAFDTGHWsE7D7D6G5A1I4J4C3B6A4==',
  localOverrideOrgId: undefined as undefined | number,
  paymentProviderConfigs: [
    {
      provider: 'Stripe',
      script: {
        url: 'https://js.stripe.com/v3/?advancedFraudSignals=false',
      }
    },
    {
      provider: 'BrainTree',
      script: {
        url: 'https://js.braintreegateway.com/web/dropin/1.21.0/js/dropin.min.js',
        integrityAttribute: 'sha384-sCbbwWTVvIbqipVITlKlgdBuYjpWAGiKzeZ5amZ09JrVyCNFDBTbfIGPbpVueypQ',
        crossOriginAttribute: 'anonymous',
      }
    },
    {
      provider: 'PaySafe',
      script: {
        url: 'https://hosted.paysafe.com/checkout/v1/latest/paysafe.checkout.min.js',
      }
    },
  ]
};
